import { ApplicationRef, ComponentFactoryResolver, ComponentRef, Component, Injector, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { ProfileServiceProxy } from '@shared/service-proxies/service-proxies';
import { IAjaxResponse, TokenService } from '@node_modules/abp-ng2-module';
import { AppConsts } from '@shared/AppConsts';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { ChangeEvent } from '@ckeditor/ckeditor5-angular/ckeditor.component';
import { CKFinderObj } from 'assets/CKFinderScripts/ckfinder.js'
import { AiEditorModalComponent } from './ai-editor.component';
// import Editor from 'ckeditor5-custom-build/build/ckeditor';
import {
	ClassicEditor, Bold, Essentials, Italic, Mention, Paragraph, Undo,
	CKFinder,
	CKFinderUploadAdapter,
	Alignment,
	AutoImage,
	Autoformat,
	AutoLink,
	BlockQuote,
	CloudServices,
	Code,
	CodeBlock,
	FindAndReplace,
	FontBackgroundColor,
	FontColor,
	FontFamily,
	FontSize,
	GeneralHtmlSupport,
	Heading,
	Highlight,
	HorizontalLine,
	HtmlComment,
	HtmlEmbed,
	Image,
	ImageResizeEditing,
	ImageResizeHandles,
	ImageCaption,
	ImageInsert,
	ImageResize,
	ImageStyle,
	ImageToolbar,
	ImageUpload,
	Indent,
	IndentBlock,
	Link,
	LinkImage,
	List,
	ListProperties,
	MediaEmbed,
	MediaEmbedToolbar,
	PasteFromOffice,
	SourceEditing,
	SpecialCharacters,
	SpecialCharactersArrows,
	SpecialCharactersCurrency,
	SpecialCharactersEssentials,
	SpecialCharactersLatin,
	SpecialCharactersMathematical,
	SpecialCharactersText,
	StandardEditingMode,
	Strikethrough,
	Style,
	Table,
	TableCaption,
	TableCellProperties,
	TableColumnResize,
	TableProperties,
	TableToolbar,
	TextTransformation,
	Underline,
	RemoveFormat
} from 'ckeditor5';
import { UploadFileAdapter } from './uploadFileAdapter';
import SourceEditingEnhanced from './source-editing-enhanced.plugin';
import AiSourceEditing from './ai-source-editing-enhanced.plugin';
// import 'ckeditor5/ckeditor5.css';
@Component({
	selector: 'html-editor',
	templateUrl: './html-editor.component.html',
	styleUrls: ['./html-editor.component.css']
})
export class HtmlEditorComponent extends AppComponentBase implements OnInit {
	@Input() data: string;
	public dataPrivate;
	public configHtml;
	@Output() dataChange = new EventEmitter();
	public Editor = ClassicEditor;
	constructor(private injector: Injector,
		    private cfr: ComponentFactoryResolver,
			  private appRef: ApplicationRef,
		private _tokenService: TokenService, private _httpClient: HttpClient,) {
		super(injector);
	}
	public config = {
		plugins: [CKFinder,
			CKFinderUploadAdapter,
			Alignment,
			AutoImage,
			Autoformat,
			AutoLink,
			BlockQuote,
			Bold,
			CloudServices,
			Code,
			CodeBlock,
			Essentials,
			FindAndReplace,
			FontBackgroundColor,
			FontColor,
			FontFamily,
			FontSize,
			GeneralHtmlSupport,
			Heading,
			Highlight,
			HorizontalLine,
			HtmlComment,
			HtmlEmbed,
			Image,
			ImageResizeEditing,
			ImageResizeHandles,
			ImageCaption,
			ImageInsert,
			ImageResize,
			ImageStyle,
			ImageToolbar,
			ImageUpload,
			Indent,
			IndentBlock,
			Italic,
			Link,
			LinkImage,
			List,
			ListProperties,
			MediaEmbed,
			MediaEmbedToolbar,
			Paragraph,
			PasteFromOffice,
			SpecialCharacters,
			SpecialCharactersArrows,
			SpecialCharactersCurrency,
			SpecialCharactersEssentials,
			SpecialCharactersLatin,
			SpecialCharactersMathematical,
			SpecialCharactersText,
			StandardEditingMode,
			Strikethrough,
			Style,
			Table,
			TableCaption,
			TableCellProperties,
			TableColumnResize,
			TableProperties,
			TableToolbar,
			TextTransformation,
			Underline,
			RemoveFormat,
			SourceEditingEnhanced,
			AiSourceEditing
		],
		toolbar: [
			'sourceEditingEnhanced',
			'aisourceEditing',
			'removeFormat',
			'fontFamily',
			'heading',
			'ckfinder',
			'|',
			'highlight',
			'fontSize',
			'fontColor',
			'bold',
			'italic',
			'underline',
			'link',
			'bulletedList',
			'numberedList',
			'|',
			'alignment',
			'outdent',
			'indent',
			'|',
			'blockQuote',
			'insertTable',
			'mediaEmbed',
			'undo',
			'redo',
			'specialCharacters',
			'htmlEmbed',
			'horizontalLine',
			'fontBackgroundColor',
			'findAndReplace',
			'codeBlock',
			'code'],
		image: {
			resizeOptions: [
				{
					name: 'resizeImage:original',
					value: null,
					label: 'Original'
				},
				{
					name: 'resizeImage:custom',
					label: 'Custom',
					value: 'custom'
				},
				{
					name: 'resizeImage:40',
					value: '40',
					label: '40%'
				},
				{
					name: 'resizeImage:50',
					value: '50',
					label: '50%'
				},
				{
					name: 'resizeImage:60',
					value: '60',
					label: '60%'
				},
				{
					name: 'resizeImage:70',
					value: '70',
					label: '70%'
				},
				{
					name: 'resizeImage:80',
					value: '80',
					label: '80%'
				},
				{
					name: 'resizeImage:90',
					value: '90',
					label: '90%'
				},
				{
					name: 'resizeImage:100',
					value: '100',
					label: '100%'
				}
			],
			toolbar: ['toggleImageCaption', 'imageTextAlternative', '|',
				{
					// Grouping the buttons for the icon-like image styling
					// into one dropdown.
					name: 'imageStyle:pictures',
					title: 'Style',
					items: [
						'imageStyle:alignLeft',
						'imageStyle:alignRight',
						'imageStyle:alignBlockLeft',
						'imageStyle:alignBlockRight',
						'imageStyle:alignCenter',
					],
					defaultItem: 'imageStyle:alignCenter'
				},
				'|',
				'resizeImage', 'linkImage'],
			insert: {
				// If this setting is omitted, the editor defaults to 'block'.
				// See explanation below.
				type: 'block'
			}
		},
		fontFamily: {
            options: [
                'default',
                '"Mulish", sans-serif',
            ]
        },
		mediaEmbed: {
			previewsInData: true,
			extraProviders: [
				{
					name: 'localVideoFile',
					url: /.(flv|mp4|avi)/,
					// html: (match) => `The HTML representing the media with ID=${ console.log(match)}.`,
					html: match =>
						'<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;">' +
						`<video style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;"  controls="" autoplay="" name="media"><source src="${match.input}" type="video/mp4"></video>` +
						'</div>'
				},
				{
					name: 'localPdfFile',
					url: /.(pdf)/,
					// html: (match) => `The HTML representing the media with ID=${ console.log(match)}.`,
					html: match =>
						`<iframe src="${match.input}" width="100%" height="800px" frameborder="0" > </iframe>`
				}
			]
		},
		licenseKey: 'EUNUV69XE5M1WFV7K3XY4BBPVGFLQ',
		mention: {
			// Mention configuration
		},
		table: {
            defaultHeadings: { rows: 1},
			contentToolbar: [ 'tableColumn', 'tableRow', 'mergeTableCells','tableCellProperties' ,'tableProperties','toggleTableCaption' ],
			tableProperties:{
				defaultProperties: {
					borderStyle: 'solid',
					borderColor: 'hsl(0, 0%, 90%)',
					borderWidth: '3px',
					alignment: 'left'
				}
			},
			tableCellProperties:{
				defaultProperties: {
					borderStyle: 'solid',
					horizontalAlignment: 'left',
					verticalAlignment: 'middle',
					padding: '5px'
				}
			}
        },
		htmlSupport: {
			allow: [
				{
					name: /^(div|section|article|.*)$/,
					attributes: true,
					classes: true,
					styles: true
				}
			]
		},
		ckfinder: {
            // Upload the images to the server using the CKFinder QuickUpload command.
            uploadUrl: '',
			options: {
			}
		}

	}



	ngOnInit() {
		
		var token = this._tokenService.getToken();
		var baseCkfinderUrl = AppConsts.ckfinderBaseUrl;
		this.config.ckfinder.uploadUrl = baseCkfinderUrl+'/ckfinder/connector?command=QuickUpload&type=Images&responseType=json&token=' + token;
		window["CKFinder"].config({
			language: 'vi',
			connectorInfo: "token=" + token,
			connectorPath: baseCkfinderUrl + '/ckfinder/connector',
			filebrowserBrowseUrl: baseCkfinderUrl + '/ckfinder/ckfinder.html',
			filebrowserImageBrowseUrl: baseCkfinderUrl + '/ckfinder/ckfinder.html?type=Images',
			filebrowserFlashBrowseUrl: baseCkfinderUrl + '/ckfinder/ckfinder.html?type=Flash',
			filebrowserUploadUrl: baseCkfinderUrl + '/ckfinder/connector?command=QuickUpload&type=Files',
			filebrowserImageUploadUrl: baseCkfinderUrl + '/ckfinder/connector?command=QuickUpload&type=Images',
			filebrowserFlashUploadUrl: baseCkfinderUrl + '/ckfinder/connector?command=QuickUpload&type=Flash'
		});

		this.dataPrivate = this.data;
		debugger
		(window as any).openAiEditorModal = (initialHtml: string, callback: (newHtml: string) => void) => {
			const factory = this.cfr.resolveComponentFactory(AiEditorModalComponent);
			const compRef: ComponentRef<any> = factory.create(this.injector);
			compRef.instance.initialHtml = initialHtml || '';
			const subSave = compRef.instance.save.subscribe((html: string) => {
				try { callback && callback(html); } finally { subSave.unsubscribe(); }
			});
			const subClose = compRef.instance.closed.subscribe(() => {
				cleanup();
				subClose.unsubscribe();
			});

			this.appRef.attachView(compRef.hostView);
			const domElem = (compRef.hostView as any).rootNodes[0] as HTMLElement;
			document.body.appendChild(domElem);

			const cleanup = () => {
				try { this.appRef.detachView(compRef.hostView); } catch {}
				try { compRef.destroy(); } catch {}
			};

			// return close function if needed
			return {
				close: () => cleanup()
			};

  		};

	}

	public onChange({ editor }: ChangeEvent) {

		this.data = editor.data.get();
		this.dataChange.emit(this.data);
	}
	onReady(editor: ClassicEditor): void {
	
		// editor.plugins.get( 'FileRepository' ).createUploadAdapter = ( loader ) => {

		//     return new UploadFileAdapter( loader, this._tokenService );
		// };
	}

}